// Safety limits to prevent Zoho account blocking
export const EMAIL_LIMITS = {
  // Maximum recipients that can be selected at once for bulk sending
  MAX_BULK_RECIPIENTS: 25, // Safe limit to prevent Zoho rate limiting
  
  // Maximum recipients per batch when sending
  MAX_BATCH_SIZE: 25,
  
  // Delay between batches (in milliseconds)
  BATCH_DELAY: 2000, // 2 seconds between batches
};

export const getBulkEmailWarning = (selectedCount, maxCount) => {
  if (selectedCount > maxCount) {
    return `⚠️ You can only select up to ${maxCount} recipients at a time to prevent email service blocking. Please select ${maxCount} or fewer recipients.`;
  }
  return null;
};

